import Tr from 'translations/Translations';
import RouterPath from 'libs/RouterPath';
import {DemandValidation, DemandValidationKeys, DemandValidationTr} from 'constants/DemandValidation';

const createItem = (trKey, steps = [], href, hrefExpand = []) => ({
    title: Tr(trKey),
    steps,
    href,
    hrefExpand
})

const createStep = (apiId, confirmClosing= false) => ({
    key: DemandValidationKeys[apiId],
    label: DemandValidationTr[apiId],
    apiId,
    confirmClosing
});

const rp = RouterPath.myProcedure.steps;

export default [
    createItem('mp_1', [
        createStep(DemandValidation.DEMAND, true),
        createStep(DemandValidation.COMMISSION, true),
        createStep(DemandValidation.QUESTIONNAIRE),
        createStep(DemandValidation.DEALINGS, true),
        createStep(DemandValidation.SCHEDULE, true),
        createStep(DemandValidation.SIWZ),
        createStep(DemandValidation.ENOTICES2, true),
        createStep(DemandValidation.ESPD),
        createStep(DemandValidation.NOTICE),
        createStep(DemandValidation.NATIONAL_NOTICE),
        createStep(DemandValidation.PREPARING_ADDITIONAL_INFO),
        createStep(DemandValidation.APPROVAL),
        createStep(DemandValidation.PUBLICATION),
        createStep(DemandValidation.CONTRACTOR),
        createStep(DemandValidation.GUARANTEE),
        createStep(DemandValidation.EX_POST_GO_TO_FINISH),
        createStep(DemandValidation.PREPARING_PAPERS_GENERATOR),
    ], rp.MP_1, [rp.MP_1]),
    createItem('mp_2', [], rp.MP_2),
    createItem('mp_3', [
        createStep(DemandValidation.OFFERS),
        createStep(DemandValidation.DOCUMENTS),
        createStep(DemandValidation.CONTRACTOR_VERIFICATION),
        createStep(DemandValidation.OFFERS_EVALUATION),
        createStep(DemandValidation.OFFER_CHOICE),
        createStep(DemandValidation.OFFER_CHOICE_APPROVAL),
        createStep(DemandValidation.ADDITIONAL_ROUND_PASSIVE),
        createStep(DemandValidation.PRIMARY_TENDER_CHOICE),
        createStep(DemandValidation.OFFERS_CHOICE_RESULT),
        createStep(DemandValidation.EVALUATION_ADDITIONAL_INFO),
        createStep(DemandValidation.EVALUATION_FINISH),
        createStep(DemandValidation.STAGE_FINISH),
        createStep(DemandValidation.PAPERS_GENERATOR),
        createStep(DemandValidation.AGREEMENTS),
    ], rp.MP_3, [rp.MP_3]),
    createItem('mp_4', [
        createStep(DemandValidation.RESULT_NOTICE),
        createStep(DemandValidation.FINISH_DOCUMENTS),
        createStep(DemandValidation.DEMAND_PLAN_REALIZATION),
        createStep(DemandValidation.FINISH_ADDITIONAL_INFO),
        createStep(DemandValidation.FINISH_DEMAND),
        createStep(DemandValidation.ARCHIVING),
    ], rp.MP_4, [rp.MP_4]),
]